import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { DateTime } from 'luxon';

import styles from './DateToken.module.css';
import {
	ACCESS_TOKEN_EXPIRATION_KEY,
	AUTH_KEY,
} from '../../views/home/auth/Authentication.hooks';

import { NavbarIconLogo } from '../../constants';
import { Icon } from '../../components/icon/Icon';

import config from '../../config';
import { useBackUrl } from '../../App.hooks';
import { AuthDateToken } from '../../config.type';

export const DateToken = () => {
	return (
		<div className={styles['container']}>
			<div className={styles['view']}>
				<Topbar />
				<Content />
			</div>
		</div>
	);
};

function Topbar() {
	return (
		<div className={styles['topbar']}>
			<div>
				<BackButton />
			</div>
			<div className={styles['title']}>
				<NavbarIconLogo />
			</div>
			<div></div>
		</div>
	);
}

function BackButton() {
	const url = useBackUrl();
	return (
		<button id="back-button" type="button" title="Back">
			<Link to={url}>
				<Icon id={'back-btn'} name={'arrow-left'} color={'#333'} />
			</Link>
		</button>
	);
}

function Content() {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const [dateToken, setDateToken] = useState('');
	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		try {
			validateToken(dateToken);
			navigate('/');
		} catch (e: any) {
			alert(e.message);
		}
	};

	useEffect(() => {
		if (!searchParams) return;
		const code = searchParams.get('e');
		if (!code) return;
		try {
			validateToken(code);
			setDateToken(code);
			navigate('/');
		} catch (e: any) {
			alert(e.message);
		}
	}, [searchParams]);
	return (
		<div className={styles['content']}>
			<form onSubmit={onSubmit}>
				<h4>Authenticate</h4>
				<p>Please authenticate</p>
				<input
					required
					onChange={(e) => {
						const { value } = e.target;
						setDateToken(value);
					}}
					placeholder="Insert token"
					value={dateToken}
					title="Date Token"
					type={'number'}
				/>

				<button type={'submit'} title="Send">
					Send
				</button>
			</form>
		</div>
	);
}

function validateToken(code: any) {
	if (isNaN(code)) {
		throw new Error('Invalid token');
	}

	if (Number.isInteger(code)) {
		throw new Error('Invalid number token');
	}

	const auth = config.app.auth as AuthDateToken;

	const dateNumber = parseInt(code) / parseInt(`${auth.config.multiplier}`);
	console.log(`Date number`, dateNumber);
	if (!Number.isInteger(dateNumber)) {
		throw new Error('Invalid token');
	}

	const date = `${dateNumber}`;

	if (date.length !== 8) {
		throw new Error('Invalid token');
	}

	const year = date.substring(0, 4);
	const month = date.substring(4, 6);
	const day = date.substring(6, 8);

	const accessExpirationDate = DateTime.fromFormat(
		`${day}/${month}/${year}`,
		'd/M/yyyy',
	);
	if (!accessExpirationDate.isValid) {
		throw new Error('Invalid token date');
	}
	const now = DateTime.now();

	// If now is larger than refresh expiration date clear the tokens
	if (now >= accessExpirationDate) {
		throw new Error('Token already expired');
	}

	localStorage.setItem(AUTH_KEY, 'true');
	localStorage.setItem(
		ACCESS_TOKEN_EXPIRATION_KEY,
		accessExpirationDate.toISO(),
	);
}

export default DateToken;
